export const productsData = {
  lifeStage: {
    male: {
      ACT: [35, 31, 133],
      NSW: [35, 31, 133],
      NT: [38, 33, 140],
      QLD: [35, 31, 127],
      SA: [40, 37, 166],
      TAS: [38, 33, 139],
      VIC: [34, 31, 120],
      WA: [38, 33, 140],
      max: [40, 37, 166],
    },
    couple: {
      ACT: [35, 31, 138],
      NSW: [35, 31, 138],
      NT: [38, 33, 145],
      QLD: [35, 31, 132],
      SA: [40, 37, 171],
      TAS: [38, 33, 144],
      VIC: [34, 31, 129],
      WA: [38, 33, 145],
      max: [40, 37, 171],
    },
    family: {
      ACT: [33, 28, 126],
      NSW: [34, 28, 125],
      NT: [36, 30, 130],
      QLD: [34, 28, 119],
      SA: [39, 34, 157],
      TAS: [36, 30, 129],
      VIC: [33, 28, 117],
      WA: [36, 30, 130],
      max: [39, 34, 157],
    },
    single_parent: {
      ACT: [34, 28, 127],
      NSW: [34, 28, 127],
      NT: [36, 30, 132],
      QLD: [34, 28, 121],
      SA: [39, 34, 159],
      TAS: [36, 30, 132],
      VIC: [33, 28, 119],
      WA: [36, 30, 132],
      max: [39, 34, 159],
    },
  },
  max: [40, 37, 171],
};

productsData.lifeStage.female = productsData.lifeStage.male;
